export const PERMITTED_IP_FIELD = "permittedIpAddress";
